module.exports = __webpack_public_path__ + "static/header_cellphone-b0de6f5321f94c52e9fdee34768937bb.png";